module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"padded\">\n	<table class=\"form-table\">\n		<tr>\n			<td colspan=\"2\">\n				<div class=\"title\">Форматы представления данных</div>\n				<div class=\"distribution-formats\"></div>\n				<div class=\"buttons\"><button on-click=\"addFormat\">Добавить</button></div>\n			</td>\n		</tr>\n		<tr>\n			<td colspan=\"2\">\n				<div class=\"title\">Носители информации</div>\n				<div class=\"distribution-digitaltransfer\"></div>\n				<div class=\"buttons\"><button on-click=\"addDigitalTransferOptions\">Добавить</button></div>\n			</td>\n		</tr>\n	</table>\n</div>\n")
  }
  return __output.join("");

}